<script setup>
// ============================================================================
// BonBoZ: "Số hội thoại theo thời gian trong ngày" — đường có tô nền, kiểu
// Pancake.
//
// 24 ĐIỂM, 4 NHÃN. Vẽ đủ 24 giờ để thấy đúng hình dạng của ngày (đỉnh trưa,
// đáy 3 giờ sáng), nhưng chỉ ghi nhãn ở bốn mốc — 24 nhãn trên khung rộng
// 400px thì chồng lên nhau thành một vệt đen.
//
// Trục hoành là GIỜ TRONG NGÀY, không phải ngày tháng: mọi ngày trong kỳ được
// gộp lại. Đọc ra là "ca trực nào đông nhất", không phải "hôm nào đông nhất" —
// hai câu khác nhau, câu sau đã có biểu đồ trên cùng trả lời.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Tooltip,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';
import { mauCss } from 'dashboard/helper/mauBieuDo';

const props = defineProps({
  // [{ gio, so }] — luôn đủ 24 phần tử, builder đảm bảo.
  diem: { type: Array, default: () => [] },
  ten: { type: String, default: '' },
});

ChartJS.register(
  Tooltip,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const duLieu = computed(() => ({
  labels: props.diem.map(d => `${d.gio}h`),
  datasets: [
    {
      data: props.diem.map(d => d.so),
      borderColor: () => mauCss('--bonboz-xong'),
      backgroundColor: () => mauCss('--bonboz-xong', 0.14),
      borderWidth: 2,
      pointRadius: 0,
      pointHoverRadius: 4,
      tension: 0.4,
      fill: true,
    },
  ],
}));

const tuyChon = computed(() => ({
  maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        // Nhãn mặc định sẽ là "10h" trơ trọi; ghi rõ khoảng một tiếng để không
        // ai đọc nhầm thành "lúc đúng 10 giờ".
        title: c =>
          `${c[0].label} – ${(Number(c[0].label.replace('h', '')) + 1) % 24}h`,
        label: c => ` ${props.ten}: ${c.formattedValue}`,
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: {
        font: { size: 11 },
        maxRotation: 0,
        // Chỉ giữ nhãn ở 0h, 6h, 12h, 18h — bốn mốc của Pancake.
        callback(giaTri, i) {
          return i % 6 === 0 ? this.getLabelForValue(giaTri) : '';
        },
      },
    },
    y: {
      beginAtZero: true,
      ticks: { precision: 0, maxTicksLimit: 4, font: { size: 11 } },
      grid: { drawTicks: false },
      border: { display: false },
    },
  },
}));
</script>

<template>
  <Chart type="line" :data="duLieu" :options="tuyChon" />
</template>
